export default class HedinDriveContactForm {

  #element;
  #tradeCarCheckbox;
  #tradeCarDetails;


  constructor(element) {
    this.#element = element;
    this.#tradeCarCheckbox = this.#element.querySelector('#tradecar');
    this.#tradeCarDetails = this.#element.querySelector('.tradecar-details');

    this.#tradeCarCheckbox.addEventListener('change', this.#onTradeCarCheckboxChange.bind(this));
  }

  #onTradeCarCheckboxChange(event) {
    // Hide or show the trade car details
    this.#tradeCarDetails.classList.toggle('hidden', !this.#tradeCarCheckbox.checked);
  }

  static init() {
    document.querySelectorAll('.hedindrive-contact-form').forEach((form) => {
      new HedinDriveContactForm(form);
    });
  }
}
